import { TYPO } from "styles/Typo";

function EmptyData({ title }: any) {
  return (
    <div className="px-4 py-[10px] bg-gray2 rounded-[14px] border border-gray15">
      <p className={`${TYPO.TYPO7_MD} text-gray50 `}>
        {title || "아직 정보가 없어요"}
      </p>
    </div>
  );
}

export default EmptyData;
